import { render } from "./LockItInHeader.vue?vue&type=template&id=20265375&scoped=true"
import script from "./LockItInHeader.vue?vue&type=script&lang=js"
export * from "./LockItInHeader.vue?vue&type=script&lang=js"

import "./LockItInHeader.vue?vue&type=style&index=0&id=20265375&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20265375"]])

export default __exports__